import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface CurrencyState {
  targetCurrencyRate: number;
  currencyCode: string;
  currencySymbol: string;
  exchangeRates: Record<string, number> | null;
  baseCurrency: string;
  isInitialized: boolean;
  setCurrency: (code: string) => void;
  setSymbol: (symbol: string) => void;
  setTargetCurrencyRate: (rate: number) => void;
  setExchangeRates: (rates: Record<string, number> | null) => void;
  setBaseCurrency: (code: string) => void;
  setInitialized: (initialized: boolean) => void;
}

export const useCurrencyStore = create<CurrencyState>()(
  persist(
    set => ({
      targetCurrencyRate: 1, // Default to 1 (USD = USD, no conversion)
      currencyCode: 'USD',
      currencySymbol: '$',
      exchangeRates: null,
      baseCurrency: 'USD',
      isInitialized: false,
      setCurrency: code => set({ currencyCode: code }),
      setSymbol: symbol => set({ currencySymbol: symbol }),
      setTargetCurrencyRate: rate => set({ targetCurrencyRate: rate }),
      setExchangeRates: rates => set({ exchangeRates: rates }),
      setBaseCurrency: code => set({ baseCurrency: code }),
      setInitialized: initialized => set({ isInitialized: initialized }),
    }),
    {
      name: 'currency-store', // key in localStorage
    }
  )
);
